module.exports = __webpack_public_path__ + "img/plan2_faux.9953968f.png";